import React from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import request from "../../../utilities/requests";

const warnedKey = (eventId) => `chatUnheartWarned:${eventId}`;

const alreadyWarned = (eventId) => {
  try {
    return localStorage.getItem(warnedKey(eventId)) === "true";
  } catch (e) {
    return false;
  }
};

export const rememberUnheartWarned = (eventId) => {
  try {
    localStorage.setItem(warnedKey(eventId), "true");
  } catch (e) {
    return;
  }
};

export const shouldWarnBeforeUnheart = async ({ eventId, otherUser }) => {
  if (!eventId || !otherUser || alreadyWarned(eventId)) return false;
  const result = await request(
    `eventchat/context?eventId=${eventId}&otherUser=${otherUser}`
  );
  return !!(result?.success && result.available && result.threadId);
};

const UnheartDialog = ({ open, name, onConfirm, onCancel }) => {
  const { t } = useTranslation();

  return (
    <Dialog
      open={open}
      onClose={onCancel}
      fullWidth
      maxWidth="xs"
      PaperProps={{ sx: { borderRadius: "24px" } }}
    >
      <DialogTitle>{t("chat.unheart.title")}</DialogTitle>
      <DialogContent>
        <Typography sx={{ fontSize: 14, lineHeight: 1.6 }}>
          {t("chat.unheart.body", { name })}
        </Typography>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button
          className="tnfm-pill-btn"
          style={{ minHeight: 32, paddingLeft: 16, paddingRight: 16 }}
          onClick={onCancel}
        >
          {t("chat.unheart.cancel")}
        </Button>
        <Button
          className="tnfm-pill-btn"
          style={{ minHeight: 32, paddingLeft: 24, paddingRight: 24 }}
          variant="contained"
          onClick={onConfirm}
        >
          {t("chat.unheart.confirm")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default UnheartDialog;
